import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { ERROR, SET_SUCCESS } from '../../../store/types';
import TextareaField from '../../elements/form/TextareaField';
import ModalActionButton from '../../elements/ModalActionButton';
import { clearUpdatedApplication, updateApplication } from '../../../store/actions/applicationsActions';
import SelectField from '../../elements/form/SelectField';

const ApplicationStatusUpdate = ({application, reload, closeFunction}) => {
  const dispatch = useDispatch()
  const applicationsSelector = useSelector(state => state.applications)
  const [updatePayload, setUpdatePayload] = useState({
    status: application.status,
    note: ''
  });
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
      if(applicationsSelector.updatedApplication !== null) {
          dispatch({
              type: SET_SUCCESS,
              payload: 'status updated successfully!'
          })
          dispatch(clearUpdatedApplication())
          reload()
          setTimeout(() => {
              closeFunction()
          }, 50);
      }
      return () => {
          
      };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicationsSelector.updatedApplication, dispatch, closeFunction]);

  const validateForm = () => {
      let errors = {}
      if(!updatePayload.status || updatePayload.status === '') {
          errors.status = true
      }

      setValidationErrors(errors)

      return errors
  }

  const pushStatusUpdate = async () => {
    console.log(application)
      try {
          if (Object.values(validateForm()).includes(true)) {
              dispatch({
                  type: ERROR,
                  error: {response: {data: {
                      message: 'Please check the highlighted fields'
                  }}}
              })
              return
          }

          dispatch(updateApplication(application._id, updatePayload))

      } catch (error) {
          console.log(error)
          dispatch({
              type: ERROR,
              error
          })
      }
  }

  const statuses = [
    {
      label: 'Pending',
      value: 'PENDING'
    },
    {
      label: 'In Review',
      value: 'IN_REVIEW'
    },
  ]

  return (
      <div className='w-full'>
          <div className='pb-3 border-b'>
              <p className='text-sm'>Select the new status below and add a note to if required</p>
          </div>
          <div className="mt-4 w-full">
            <SelectField
                selectOptions={statuses}
                inputLabel="Select application status"
                titleField="label"
                displayImage={false}
                imageField=""
                requiredField={true}
                preSelected={updatePayload.status || ''}
                fieldId="status-select"
                hasError={validationErrors && validationErrors.status}
                // return id of accounts of the selected option
                returnFieldValue={(value) => {setUpdatePayload({...updatePayload, ...{status: value.value}})}}
            />
          </div>

          <div className='my-2 w-full'>
              <TextareaField
                  inputLabel="Note" 
                  fieldId="status-note" 
                  inputType="text" 
                  requiredField={false}
                  preloadValue={updatePayload.note || ''}
                  hasError={false} 
                  returnFieldValue={(value)=>{setUpdatePayload({...updatePayload, ...{note: value}})}}
              />
          </div>

          <div className="mt-8 flex flex-row-reverse gap-x-4">
              <ModalActionButton
                  buttonLabel={`Update application status`}
                  buttonAction={()=>{pushStatusUpdate()}}
                  processing={applicationsSelector.updatingApplication}
                />

              <button
                  type="button"
                  className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                  onClick={closeFunction}
              >
                  Cancel
              </button>
              
          </div>
      </div>
  )
}


export default ApplicationStatusUpdate